// src/pages/DirectPage/MessageInput.jsx
import React, { useState } from 'react';
import { directPageStyles } from './styles';
import ScheduleMeetButton from '../../components/ScheduleMeetButton';

// Send Icon SVG
const SendIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22 2 15 22 11 13 2 9 22 2" />
  </svg>
);

// Emoji Icon SVG
const EmojiIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" />
    <path d="M8 14s1.5 2 4 2 4-2 4-2" />
    <line x1="9" y1="9" x2="9.01" y2="9" />
    <line x1="15" y1="9" x2="15.01" y2="9" />
  </svg>
);

const MessageInput = ({ 
  text, 
  setText, 
  onSend, 
  seller,
  currentUserId
}) => {
  const [isFocused, setIsFocused] = useState(false);
  
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      if (text.trim()) {
        handleSubmit(e);
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (text.trim()) {
      onSend(e);
    }
  };

  const quickEmojis = ['👍', '❤️', '😊', '😂', '🔥', '✨', '👏', '🎉'];

  const addEmoji = (emoji) => {
    setText(text + emoji);
  };

  return (
    <div style={directPageStyles.inputContainer}>
      {/* Quick Emoji Bar */}
      <div style={directPageStyles.emojiBar}>
        <span style={directPageStyles.emojiLabel}>
          <EmojiIcon /> Quick reactions:
        </span>
        {quickEmojis.map((emoji, index) => (
          <button
            key={index}
            type="button"
            onClick={() => addEmoji(emoji)}
            style={directPageStyles.emojiButton}
            aria-label={`Add ${emoji} emoji`}
          >
            {emoji}
          </button>
        ))}
      </div>

      {/* Message Input Form */}
      <form onSubmit={handleSubmit} style={directPageStyles.inputForm}>
        <div style={directPageStyles.inputRow}>
          <input
            type="text"
            placeholder="Type a message..."
            value={text}
            onChange={(e) => setText(e.target.value)}
            style={{
              ...directPageStyles.messageInput,
              ...(isFocused ? directPageStyles.messageInputFocused : {})
            }}
            onKeyDown={handleKeyDown}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
          />
          <button 
            type="submit" 
            style={{
              ...directPageStyles.sendButton,
              ...(text.trim() ? directPageStyles.sendButtonActive : {})
            }}
            disabled={!text.trim()}
          >
            <SendIcon />
            <span>Send</span>
          </button>
          <ScheduleMeetButton
            recipientId={seller?.id}
            tabIndex={-1}
            style={seller?.id === currentUserId ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
            open={false}
            onCancel={() => {}}
            onSubmit={() => {}}
            disabled={seller?.id === currentUserId}
          />
        </div>
      </form>
    </div>
  );
};

export default MessageInput;